import { createApi } from '@reduxjs/toolkit/query/react';
import API_ROUTES from 'services/apiRoutes';
import { baseQueryWithAuth } from 'services/baseQueryWithAuth';
import {
  AdminShoppingCartCreatePayload,
  AdminShoppingCartResponse,
} from 'store/shoppingCart/types';

export const shoppingCartApi = createApi({
  reducerPath: 'shoppingCartApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['ShoppingCart'],
  endpoints: builder => ({
    getShoppingCart: builder.query<AdminShoppingCartResponse, { clientId: number | string }>({
      query: ({ clientId }) => API_ROUTES.SHOPPING_CART(clientId),
      providesTags: (result, error, { clientId }) => [
        { type: 'ShoppingCart' as const, id: clientId },
      ],
    }),

    activateShoppingCart: builder.mutation<
      AdminShoppingCartResponse,
      { clientId: number | string; body: AdminShoppingCartCreatePayload }
    >({
      query: ({ clientId, body }) => ({
        url: API_ROUTES.SHOPPING_CART(clientId),
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { clientId }) => [
        { type: 'ShoppingCart' as const, id: clientId },
      ],
    }),

    updateShoppingCart: builder.mutation<
      AdminShoppingCartResponse,
      { clientId: number | string; body: Partial<AdminShoppingCartCreatePayload> }
    >({
      query: ({ clientId, body }) => ({
        url: API_ROUTES.SHOPPING_CART(clientId),
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, { clientId }) => [
        { type: 'ShoppingCart' as const, id: clientId },
      ],
    }),
  }),
});

export const {
  useGetShoppingCartQuery,
  useActivateShoppingCartMutation,
  useUpdateShoppingCartMutation,
} = shoppingCartApi;
